export default "__VITE_ASSET__e40481ca__"